import React from 'react'
import cx from 'classnames'
import { formatPrice } from 'helpers'

import { Text } from 'components/dataDisplay'

import messages from './messages'


type ShippingStatusProps = {
  className?: string
  cart: CartModule.Cart
}

const ShippingStatus: React.FunctionComponent<ShippingStatusProps> = (props) => {
  const { className, cart } = props

  // we should use ecommerce item with is the last one
  const shipping = cart?.shipping?.[cart?.shipping?.length - 1]

  if (!shipping) {
    return null
  }

  const { freeShippingRemain, price } = shipping
  let message = null

  if (freeShippingRemain === 0 && price === 0) {
    // because Canadian users have to paid for subscription shipping, we should check, that shipping is actually free
    message = messages.qualify
  }
  else if (freeShippingRemain > 0) {
    message = {
      ...messages.remain,
      values: {
        remain: formatPrice(shipping.freeShippingRemain),
      },
    }
  }
  else {
    return null
  }

  return (
    <Text
      className={cx(className, 'text-center')}
      style="p4"
      message={message}
      html
    />
  )
}


export default ShippingStatus
